type PriceStyle = 'currency' | 'decimal' | 'percent' | 'unit'

export const formatterPrice = (price: number, style: PriceStyle = 'currency') =>
  Intl.NumberFormat('pt-BR', {
    style,
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(price)
